import { render, staticRenderFns } from "./TheSnapshotQueryGetFilesButton.vue?vue&type=template&id=96c7db48&"
import script from "./TheSnapshotQueryGetFilesButton.vue?vue&type=script&lang=js&"
export * from "./TheSnapshotQueryGetFilesButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports